import { useState } from "react";
import { Loader2, Search, X } from "lucide-react";
import { Button } from "./Button";

export function useSearchFilter() {
  const [searchInput, setSearchInput] = useState("");
  const [search, setSearch] = useState("");
  const submitSearch = (e) => {
    e.preventDefault();
    setSearch(searchInput.trim());
  };
  const clearSearch = () => {
    setSearchInput("");
    setSearch("");
  };
  return { searchInput, setSearchInput, search, setSearch, submitSearch, clearSearch };
}

export function SearchFilterForm({
  value,
  onChange,
  onSubmit,
  onClear,
  placeholder,
  children,
  loading = false,
  submitVariant = "outline",
  clearContent = <X className="h-3.5 w-3.5" />,
  inputClassName = "sm:w-52",
}) {
  return (
    <form onSubmit={onSubmit} className="flex w-full flex-col gap-2 sm:w-auto sm:flex-row sm:flex-wrap sm:items-center sm:shrink-0">
      {children}
      {/* One row below sm; sm:contents dissolves the wrapper above sm. */}
      <div className="flex items-center gap-2 sm:contents">
        <div className="relative min-w-0 flex-1 sm:flex-initial">
          <Search className="absolute left-2.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-muted-foreground" />
          <input
            type="text"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            className={`h-9 w-full rounded-md border border-input bg-background pl-8 pr-3 text-sm focus:outline-none focus:ring-2 focus:ring-ring ${inputClassName}`}
          />
        </div>
        <Button type="submit" size="sm" variant={submitVariant} className="shrink-0" aria-label="Search">
          <Search className="h-3.5 w-3.5" />
        </Button>
        {onClear && (
          <Button type="button" variant="ghost" size="sm" onClick={onClear} className="shrink-0" aria-label="Clear search">
            {clearContent}
          </Button>
        )}
        {loading && <Loader2 className="h-4 w-4 shrink-0 animate-spin text-muted-foreground" />}
      </div>
    </form>
  );
}
